import Tile from '@commons/components/Tile/Tile';

import type { CampaignPageNodeProps } from '.';

/**
 * CampaignPage node component for the Tile display type.
 */

const CampaignPageNodeTile = ({ image, title, alias }: CampaignPageNodeProps) => (
  <Tile href={alias} title={title} image={image} />
);

export default CampaignPageNodeTile;
